import React, { useEffect, useState, useRef } from "react";
import { HashLink as Link } from 'react-router-hash-link';
import Swal from "sweetalert2";
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel";
import { Modal } from 'bootstrap';

import { FaCheckCircle, FaCodeBranch, FaShieldAlt, FaBolt, FaChartLine,
        FaCashRegister,FaPalette, FaChartBar,FaHistory,FaMapMarkerAlt,
        FaFileExport, FaCode, FaLink, FaFileCode, FaBook  } from 'react-icons/fa';

const Homepage = () => {
  const headerRef = useRef();
  const handleOpenLogin = () => {
    if (headerRef.current) {
      headerRef.current.showLoginModal();
    }
  };
  const handleOpenRegister = () => {
    if (headerRef.current) {
      headerRef.current.showRegisterModal();
    }
  };
  

   useEffect(() => {
    const initSliders = () => {
      if (window.jQuery && window.jQuery.fn.slick) {
        $('.product-main').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 2000,
          arrows: false,
          centerMode: true,
          centerPadding: '0px',
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
          ]
        });

        $('.review-main').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 2000,
          arrows: false,
          centerMode: true,
          centerPadding: '0px',
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ]
        });

        $('.blog-main').slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 2000,
          arrows: false,
          centerMode: true,
          centerPadding: '0px',
          focusOnSelect: true,
          responsive: [
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
          ]
        });

        var html_body = $('html, body');
        $('.navbar a, .scroll-down a, .backtotop a').on('click', function(e) {
          if (this.hash && window.location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && window.location.hostname === this.hostname) {
            e.preventDefault();
            
            var hash = this.hash;
            
            html_body.animate({
              scrollTop: $(hash).offset().top - 65
            }, 800, function() {
              window.location.hash = hash;
            });
          }
        });

        if (window.location.hash) {
          setTimeout(function() {
            html_body.animate({
              scrollTop: $(window.location.hash).offset().top - 65
            }, 800);
          }, 1000);
        }

        $(window).on('load', function () {
          $('.preloader').delay(1000).fadeOut(1000);
        });
        setTimeout(() => {
          $('.preloader').fadeOut(1000);
        }, 2000);
        
        $(window).scroll(function () {
          var scrolling = $(this).scrollTop();
          var stikey = $('.sticky-top');

          if (scrolling >= 100) {
            $(stikey).addClass("nav-bg");
          } else {
            $(stikey).removeClass("nav-bg");
          }
          if (scrolling > 280) {
            $('.backtotop').fadeIn(500);
          } else {
            $('.backtotop').fadeOut(500);
          }
        });
      }
    };

    if (!window.jQuery) {
      const jqueryScript = document.createElement('script');
      jqueryScript.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
      jqueryScript.async = true;
      document.body.appendChild(jqueryScript);

      jqueryScript.onload = () => {
        const slickScript = document.createElement('script');
        slickScript.src = '/js/slick.min.js';
        document.body.appendChild(slickScript);

        slickScript.onload = () => {
          initSliders();

          const customScript = document.createElement('script');
          customScript.src = '/js/custom.js';
          document.body.appendChild(customScript);
        };
      };
    } else {
      if (window.jQuery.fn.slick) {
        initSliders();
      } else {
        const slickScript = document.createElement('script');
        slickScript.src = '/js/slick.min.js';
        slickScript.onload = initSliders;
        document.body.appendChild(slickScript);
      }
    }

    return () => {
      if (window.jQuery && window.jQuery.fn.slick) {
        $('.product-main, .review-main, .blog-main').slick('unslick');
      }
    };
  }, []);

    const [email, setEmail] = useState('');
    const [subscriber_website, setsubscriber_website] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleSubmit = async (event) => {
        setsubscriber_website('RefMex');
        event.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_RECEIPT_URL}/subscribe`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
               body: JSON.stringify({ email, subscriber_website: 'RefMex' }), 
            });

            if (response.ok) {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Subscription successful!',
                    showConfirmButton: false,
                    timer: 2000
                });
                setEmail('');
            } else {
                const errorResponse = await response.text();
                let errorMessage;
                try {
                    const jsonResponse = JSON.parse(errorResponse);
                    errorMessage = jsonResponse.message;
                } catch (e) {
                    errorMessage = 'An unknown error occurred';
                }
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: `Failed to subscribe: ${errorMessage}`,
                    showConfirmButton: true
                });
            }
        } catch (error) {
            console.error('Error subscribing:', error);
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'An error occurred. Please try again later.',
                showConfirmButton: true
            });
        } finally {
            setIsSubmitting(false);
        }
    };
 

const [showModal, setShowModal] = useState(false);

const handlePlanClick = (planName) => {
  formData.username = '';
  formData.email = '';
  formData.description = '';

  setFormData(prev => ({
    ...prev,
    plan: planName
  }));
};

const handleCloseModal = () => {
  setShowModal(false);
  setFormData(prev => ({ ...prev, plan: '' }));
};

const [formData, setFormData] = useState({
  username: '',
  email: '',
  description: '',
  plan: ''
});

const [isContactSubmitting, setIsContactSubmitting] = useState(false);

const handleContactSubmit = async (event) => {
  event.preventDefault();
  setIsContactSubmitting(true);

  try {
    const subject = formData.plan 
      ? `Someone wants to buy ${formData.plan} plan of RefMex` 
      : 'Someone contacted you from RefMex.com';

    const response = await fetch(`${process.env.REACT_APP_RECEIPT_URL}/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...formData,
        subject
      }),
    });

    if (response.ok) {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Message sent successfully!',
        showConfirmButton: false,
        timer: 2000
      });
      setFormData({
        username: '',
        email: '',
        description: '',
        plan: ''
      });
    } else {
      const errorResponse = await response.text();
      let errorMessage;
      try {
        const jsonResponse = JSON.parse(errorResponse);
        errorMessage = jsonResponse.message;
        setFormData({
        username: '',
        email: '',
        description: '',
        plan: ''
      });
      } catch (e) {
        errorMessage = 'An unknown error occurred';
        setFormData({
        username: '',
        email: '',
        description: '',
        plan: ''
      });
      }
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: `Failed to send message: ${errorMessage}`,
        showConfirmButton: true
      });
      setFormData({
        username: '',
        email: '',
        description: '',
        plan: ''
      });
    }
  } catch (error) {
    console.error('Error sending message:', error);
    Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'An error occurred. Please try again later.',
      showConfirmButton: true
    });
    setFormData({
        username: '',
        email: '',
        description: '',
        plan: ''
      });
  } finally {
    setIsContactSubmitting(false);
  }
};

return(
    <>
    <style>
      {
        `
        .check-style {
            color: #0553d9 !important;
            font-size: 18px !important;
            padding-right: 4px !important;
        }
        
        .slider-text{
            font-size: 14px !important;
            color: #666 !important;
            padding-bottom: 14px !important;
        }

        .questions{
            font-size:18px !important;
            color: #666 !important;
            padding-bottom: 18px !important;
        }
        .product-txt p {
            color: #787878;
            line-height: 27px;
            font-size: 17px;
            padding-bottom: 30px;
        }
        .question-span{
          display: flex !important;
          align-items: center !important;
          font-size: 20px !important;
        }
        `
      }
    </style>

    <Header ref={headerRef} />
    <div className="container-fluid">
        <div className="preloader">
            <div className="frame">
                <div className="center">
                    <div className="dot-1"></div>
                    <div className="dot-2"></div>
                </div>
            </div>
        </div>      
    

    {/* BANNER AREA START  */}
    <section id="banner">
        <div className="design-layer"></div>
        <div className="backtotop">
            <a href="#banner"><i className="fa fa-arrow-up" aria-hidden="true"></i></a>
        </div>
        <div className="container zindex">
            <div className="row">
                <div className="col-lg-6 banner-txt">
                    <h3>“Turn Happy Customers Into Your Best Marketers.”</h3>
                   <p>Refmex helps stores grow through word-of-mouth. Share referral links via QR codes or messages — customers earn loyalty points for every successful referral, and their friends enjoy instant discounts.</p>
                 <div className="button-group banner-buttons d-flex">
                
                <a
                  className="nav-link bor"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    const contactModal = new Modal(document.getElementById('ContactModal'), {
                      backdrop: true,
                      keyboard: true
                    });
                    contactModal.show();
                  }}
                >
                  Book a Free Trial
                </a>
                  </div>

                </div>
                <div className="col-lg-6">
                    <div className="banner-img">
                        <img src="images/banner-image.png" alt="banner-img" className="banner-image"/>
                    </div>
                </div>
            </div>
        </div>
        <div
          className="modal fade"
          id="ContactModal"
          tabIndex="-1"
          aria-labelledby="ContactModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="ContactModalLabel">Contact Us</h5>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  const username = e.target.username.value;
                  const email = e.target.email.value;
                  const message = e.target.message.value;
        
                  try {
                    const response = await fetch(`${process.env.REACT_APP_RECEIPT_URL}/contact`, {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({
                        username,
                        email,
                        description: message,
                        subject: "Contact message from Refmex site"
                      }),
                    });
        
                    if (response.ok) {
                      Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Message sent successfully!",
                        showConfirmButton: false,
                        timer: 2000,
                      });
                      e.target.reset();
                      const modalEl = document.getElementById('ContactModal');
                      const modal = Modal.getInstance(modalEl);
                      modal.hide();
                    } else {
                      const errText = await response.text();
                      Swal.fire({
                        icon: "error",
                        title: "Failed to send message",
                        text: errText || "Please try again later",
                      });
                    }
                  } catch (err) {
                    console.error(err);
                    Swal.fire({
                      icon: "error",
                      title: "An error occurred",
                      text: "Please try again later",
                    });
                  }
                }}
              >
                <div className="modal-body">
                  <div className="mb-3">
                    <input
                      type="text"
                      name="username"
                      className="form-control box-bg"
                      placeholder="Your Name"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="email"
                      name="email"
                      className="form-control box-bg"
                      placeholder="Your Email"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <textarea
                      name="message"
                      className="form-control box-bg"
                      placeholder="Your Message"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn dropboxx2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="submit" className="btn dropboxx2">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
    </section>
    {/* BANNER AREA ENDS */}

    {/* THE PROBLEM SECTION STARTS */}
     <section id="about">
        <div className="container">
          <div className="row header-text text-center">
            <div className="col-lg-12">
              <h3 className="text-uppercase heading-mobile" >Stop Wasting Money on Expensive Ads - <span>G</span>row Organically</h3>
            </div>
          </div> 
          <div className="row review-pa">
            <div className="col-lg-10 col-md-12 m-auto ">
              <div className="row">
                <div className="col-lg-4 col-sm-8 m-sm-auto m-md-auto m-lg-auto  col-md-5 text-center">
                    <img src="images/guessing.png" alt="about-img" className="guessing-image" style={{objectFit:'contain', height:'455px'}}/>
                </div>
                <div className="col-lg-1 col-md-1"></div>
                <div className="col-lg-7 col-md-6">
                  <div className="about-txt">
                    <p className="mt-4" >Traditional advertising drains your budget without building lasting customer relationships. People trust recommendations from friends 10x more than any ad.</p>
                    <p className="separate-p tab-hider">RefMex provides an automated, cost-effective solution that turns your point-of-sale into a powerful customer acquisition engine. Leverage your happiest customers to drive qualified, high-converting leads directly to your business.</p>
                   
                  <p className="question-span">
                    <FaBolt style={{color: "#0553d9", marginRight: "4px"}} /> Seamless Referral Experience
                  </p>
                  <p className="question-span">
                    <FaChartLine style={{color: "#0553d9", marginRight: "4px"}} /> Automated Loyalty Tracking
                  </p>
                  <p className="question-span">
                    <FaCashRegister style={{color: "#0553d9", marginRight: "4px"}} /> QR Code & Link Sharing
                  </p>           
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    {/* THE PROBLEM SECTION ENDS */}

   {/* HOW IT WORKS AREA START */}
      <section id="team">
        <div className="container">
          <div className="row header-text text-center">
            <div className="col-lg-12">
              <h3 className="text-uppercase heading-mobile" >The Referral Process - Simple, Fast, and <span>E</span>ffective</h3>
            </div>
          </div>
          <div className="row review-pa">
            <div className="col-lg-3 col-md-3 col-sm-4 m-auto team-item text-center"  >
              <img src="images/pos.png" alt="team-member" className="pos-img"  style={{objectFit:'contain', height:'306px'}} />
              <h3>Step 1: Share Your Unique Referral Code</h3>
              <p>Customers easily access your referral program by scanning QR codes at checkout or tapping shareable links - no app downloads required.</p>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-4 m-auto team-item text-center"  >
              <img src="images/friends.PNG" className="build-form-img" alt="team-member" style={{objectFit:'contain', height:'306px'}} />
              <h3>Step 2: Refer Friends & Earn Rewards</h3>
              <p>Customers refer friends by entering their contact information. The system automatically sends personalized discount invitations.</p>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-4 m-auto team-item text-center" >
              <img src="images/insights.png" alt="team-member" className="insights-img"  style={{objectFit:'contain', height:'306px'}} />
               <h3>Step 3: Redeem Loyalty Points</h3>
              <p>For every successful referral, customers instantly earn loyalty points redeemable for discounts, free products, or exclusive perks at your store.</p>
            </div>
          </div>
        </div>
      </section>
      {/* HOW IT WORKS AREA ENDS */}

    {/* INDUSTRY-SPECIFIC SOLUTIONS START */}
  <section id="product">
        <div className="container">
          <div className="row header-text text-center">
            <div className="col-lg-12">
              <h3 className="text-uppercase heading-mobile" >Optimized for Your <span>I</span>ndustry</h3>
            </div>
          </div>
          <div className="row text-center">
            <div className="col-lg-12">
              <h3 className="mt-3" >"Customized Referral Programs That Drive Results"</h3>
               <h6 className="mt-3" >Different businesses have different customer behaviors - we've tailored our solution accordingly</h6>
            </div>
          </div>
          <div className="row review-pa" >
            <div className="col-lg-12">
              <div className="product-main">
                <div className="col-lg-12">
                  <div className="product-slider text-center">
                    <div className="pro-img">
                      <img src="images/restaurant.png" alt="product-img"/>
                    </div>
                    <div>
                      <h3>Restaurants & Cafés</h3>
                      <span className="slider-text">Encourage repeat visits with friend-referral rewards and table codes</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="product-slider text-center">
                    <div className="pro-img">
                      <img src="images/hair-cut.png" alt="product-img"/>
                    </div>
                    <div >
                      <h3>Salons & Barbershops</h3>
                      <span className="slider-text">Track stylist referrals and reward clients for new bookings</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="product-slider text-center">
                    <div className="pro-img">
                      <img src="images/spa.png" alt="product-img"/>
                    </div>
                    <div >
                      <h3>Spa & Wellness Centers</h3>
                      <span className="slider-text">Boost memberships with package referrals and upgrade bonuses</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="product-slider text-center">
                    <div className="pro-img">
                      <img src="images/dentist.png" alt="product-img"/>
                    </div>
                    <div >
                      <h3>Dental & Medical Clinics</h3>
                      <span className="slider-text">Build patient trust through secure referral tracking programs</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="product-slider text-center">
                    <div className="pro-img">
                      <img src="images/aesthetics.png" alt="product-img"/>
                    </div>
                    <div >
                      <h3>Aesthetic & Beauty Clinics</h3>
                      <span className="slider-text">Reward high-value treatment referrals with tiered incentives</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  </section>
    {/* INDUSTRY-SPECIFIC SOLUTIONS END */}

{/* DEVELOPER-FRIENDLY INTEGRATION */}
<section id="product">
  <div className="container">
    <div className="row header-text text-center">
      <div className="col-lg-12">
        <h3 className="text-uppercase heading-mobile"  >Seamless <span>I</span>ntegration</h3>
      </div>
    </div>
    <div className="row text-center">
      <div className="col-lg-12">
        <h3 className="mt-3">"Built for Technical Teams, Loved by Business Owners"</h3>
      </div>
    </div>
    <div className="row review-pa">
      <div className="col-12">
        <div className="row align-items-center">
          <div className="col-12 col-md-4 order-1 order-md-2 text-center mb-4 mb-md-0">
            <img
              src="images/developer.png"
              alt="Developer Illustration"
              style={{ maxHeight: '100%', width: '100%' }}
            />
          </div>
          <div className="col-12 col-md-8 order-2 order-md-1 product-txt">
            <h5>Whether you manage a single location or multiple branches, RefMex integrates smoothly with your existing systems:</h5>
            <div className="mt-4">
              <p className="question-span">
                <FaCode style={{ color: "#0553d9", marginRight: "4px" }} /> REST APIs for POS & CRM Integration
              </p>
              <p className="question-span">
                <FaLink style={{ color: "#0553d9", marginRight: "4px" }} /> Real-time Webhooks for Referral Updates
              </p>
              <p className="question-span">
                <FaFileCode style={{ color: "#0553d9", marginRight: "4px" }} /> Pre-built Integration Templates
              </p>
              <p className="question-span">
                <FaBook style={{ color: "#0553d9", marginRight: "4px" }} /> Comprehensive API Documentation
              </p>
            </div>
            <div className="row mb-5 px-2">
              <div className="col-12">
                <h5>No complicated SDKs or vendor lock-in. Just clean, efficient integration that works.</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

{/* ANALYTICS & REPORTING SECTION */}
<section id="product">
  <div className="container">
    <div className="row header-text text-center">
      <div className="col-lg-12">
        <h3 className="text-uppercase heading-mobile" >Performance <span>A</span>nalytics</h3>
      </div>
    </div>
    <div className="row text-center">
      <div className="col-lg-12">
        <h3 className="mt-3">"Data-Driven Insights to Optimize Your Referral Strategy"</h3>
      </div>
    </div>
    <div className="row review-pa">
      <div className="col-12">
        <div className="row align-items-center">
          <div className="col-12 col-md-4 order-1 order-md-2 text-center mb-4 mb-md-0">
            <img
              src="images/track.png"
              alt="Analytics Dashboard"
              style={{ maxHeight: '100%', width: '100%' }}
            />
          </div>
          <div className="col-12 col-md-8 order-2 order-md-1 product-txt">
            <h5>Make informed decisions with comprehensive analytics and reporting:</h5>
            <div className="mt-4">
              <p className="question-span">
                <FaChartBar style={{ color: "#0553d9", marginRight: "4px" }} /> Referral Conversion Rates & ROI
              </p>
              <p className="question-span">
                <FaChartLine style={{ color: "#0553d9", marginRight: "4px" }} /> Top Performing Referrers & Campaigns
              </p>
              <p className="question-span">
                <FaHistory style={{ color: "#0553d9", marginRight: "4px" }} /> Customer Lifetime Value Tracking
              </p>
              <p className="question-span">
                <FaMapMarkerAlt style={{ color: "#0553d9", marginRight: "4px" }} /> Location-Based Performance Analysis
              </p>
              <p className="question-span">
                <FaFileExport style={{ color: "#0553d9", marginRight: "4px" }} /> Custom Report Export (CSV/Excel)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  {/* FEATURES SECTION */}
  <section id="overview">
    <div className="container">
        <div className="row header-text text-center">
            <div className="col-lg-12">
                <h3 className="text-uppercase heading-mobile" ><span>F</span>eatures</h3>
            </div>
        </div>
        <div className="row review-pa">
            <div className="col-lg-9 col-sm-12 m-auto">
                <div className="row">
                    <div className="col-lg-6 col-sm-6">
                        <div className="over-item txt-right unique-style3">
                            <i className="fa fa-bolt over-i" aria-hidden="true"></i>
                            <div className="break"></div>
                            <h3>Instant Referral Activation</h3>
                            <p>Launch your referral program in minutes with QR codes and shareable links that work across all devices without additional setup requirements.</p>
                            <div className="over-btn">
                                <a href="#">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-6">
                        <div className="over-item txt-left unique-style">
                            <i className="fa fa-sliders over-i" aria-hidden="true"></i>
                            <div className="break"></div>
                            <h3>Smart Reward Automation</h3>
                            <p>Automatically track successful referrals, assign loyalty points, and manage redemption with customizable rules and expiration settings.</p>
                            <div className="over-btn">
                                <a href="#">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-6">
                        <div className="over-item txt-right unique-style2">
                            <i className="fa fa-line-chart over-i" aria-hidden="true"></i>
                            <div className="break"></div>
                            <h3>Custom Campaign Builder</h3>
                            <p>Create tailored referral campaigns with flexible reward structures, timing controls, and targeting options to match your business goals.</p>
                            <div className="over-btn">
                                <a href="#">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-sm-6">
                        <div className="over-item txt-left unique-style4">
                            <i className="fa fa-plug over-i" aria-hidden="true"></i>
                            <div className="break"></div>
                            <h3>Advanced Analytics Suite</h3>
                            <p>Gain deep insights into referral performance, customer behavior, through our comprehensive dashboard and reporting tools.</p>
                            <div className="over-btn">
                                <a href="#">Learn More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>

 {/* PRICING SECTION */}
      <section id="price">
        <div className="container">
          <div className="row header-text text-center">
            <div className="col-lg-12">
              <h3 className="text-uppercase heading-mobile" ><span>P</span>ricing</h3>
            </div>
          </div>
          <div className="row review-pa">
            <div className="col-lg-3 col-sm-6">
              <div className="price-table mob-mar-bottom">
                <h3>Free Trial</h3>
                <h4><sub>$</sub>0<sub>/Month</sub></h4>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Full Platform Access </p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Basic Referral Features</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> 14-Day Trial Period</p>
               <div className="price-btn text-center">
                <a href="#" onClick={() => handlePlanClick('Free Trial')} data-toggle="modal" data-target="#exampleModal">Start Free Trial</a>
              </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="price-table mob-mar-bottom">
                <h3>Starter</h3>
                <h4><sub>$</sub>19<sub>/Month</sub></h4>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Single Business Location</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Basic Referral Program</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> QR Code Generation</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Standard Email Support</p>
                <div className="price-btn text-center">
                  <a href="#" onClick={() => handlePlanClick('Starter')} data-toggle="modal" data-target="#exampleModal">Get Started</a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mob-mar-bottom">
              <div className="price-table gold-bg">
                <h3 className="gold">Professional</h3>
                <h4><sub>$</sub>49<sub>/Month</sub></h4>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Multi-Location Support</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Advanced Campaign Features</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Full API Access</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Priority Support</p>
                <div className="price-btn gold-bg2 text-center">
                  <a href="#" onClick={() => handlePlanClick('Professional')} data-toggle="modal" data-target="#exampleModal">Go Professional</a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="price-table">
                <h3>Enterprise</h3>
                <h4><sub>$</sub>499<sub>/Year</sub></h4>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Unlimited Locations</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Custom API Configuration</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Service Level Agreement</p>
                <p><i className="fa fa-check-circle-o" aria-hidden="true"></i> Dedicated Account Manager</p>
               <div className="price-btn text-center">
                <a href="#" onClick={() => handlePlanClick('Enterprise')} data-toggle="modal" data-target="#exampleModal">Contact Sales</a>
              </div>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* FINAL CTA SECTION */}
<section id="final-cta" style={{ backgroundColor: '#0553d9',color: '#ffffff',textAlign: 'center',}}>
  <div className="container">
    <div className="row text-center ">
      <div className="col-lg-10 mx-auto">
        <h2
          className="mb-4"
          style={{
            fontSize: '3rem',
            fontWeight: '900',
            color: '#ffffff',
            textShadow: '2px 2px 8px rgba(0, 0, 0, 0.2)',
            fontFamily: "'Poppins', sans-serif",
            lineHeight: '1.2',
          }}
        >
          Launch Your Referral Program <br /> in Under 15 Minutes
        </h2>
        <p
          className="lead mb-5"
          style={{
            fontSize: '1.25rem',
            color: '#ffffff',
            fontWeight: '500',
          }}
        >
          No setup fees. No complex training. No long-term contracts.
          <br />
          Just plug in, share your referral program, and watch your customer base grow organically.
        </p>
        <div
          className="mt-4 d-flex justify-content-center cta-buttons"
          style={{ gap: '20px', flexWrap: 'wrap' }}
        >
          <a
            href="https://wa.me/923307776551"
            style={{
              backgroundColor: '#ffffff',
              color: '#0553d9',
              padding: '14px 28px',
              borderRadius: '30px',
              textDecoration: 'none',
              fontWeight: '700',
              fontSize: '1.1rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              transition: 'all 0.3s ease',
            }}
            onMouseOver={(e) => (e.target.style.transform = 'scale(1.05)')}
            onMouseOut={(e) => (e.target.style.transform = 'scale(1)')}
          >
            Schedule a Demo
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

     
  {/* FAQ SECTION */}
  <section id="contact">
          <div className="container">
            <div className="row header-text text-center">
              <div className="col-lg-12">
                <h3 className="text-uppercase heading-mobile" >Frequently Asked <span>Q</span>uestions</h3>
              </div>
            </div>
            <div className="row review-pa">
              <div className="col-lg-8 f-text2">
                <div className="accordion" id="accordionExample">
                  <div className="card">
                    <div className="card-header" id="headingOne">
                      <h2 className="mb-0 text-left">
                        <button className="btn btn-link zom" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          How quickly can I set up my referral program?
                        </button>
                      </h2>
                    </div>
                    <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                      <div className="card-body">
                      Most businesses can launch their referral program in under 15 minutes. Our intuitive setup wizard guides you through the process, and if you need assistance, our support team is available to help you get started immediately.
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingTwo">
                      <h2 className="mb-0 text-left">
                        <button className="btn btn-link collapsed zom" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                          Is my customer data secure with RefMex?
                        </button>
                      </h2>
                    </div>
                    <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                      <div className="card-body">
                        Absolutely. We employ enterprise-grade security measures including data encryption, secure servers, and compliance with data protection regulations. Your customer information is protected with the highest security standards.
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingThree">
                      <h2 className="mb-0 text-left">
                        <button className="btn btn-link collapsed zom" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                          Can I customize the referral rewards for my business?
                        </button>
                      </h2>
                    </div>
                    <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                      <div className="card-body">
                          Yes, completely. You have full control over your reward structure - from points systems to percentage discounts, free services, or exclusive perks. You can set different rewards for different referral tiers and adjust them anytime.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mobile-space">
          <form onSubmit={handleContactSubmit}>
            <div className="form-group">
              <div className="input-group contact-input mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text faq-icon">
                    <i className="fa fa-user-o" aria-hidden="true"></i>
                  </span>
                </div>
                <input
                  type="text"
                  name="username"
                  className="form-control box-bg light-v"
                  placeholder="Your Name"
                  value={formData.username}
                  onChange={(e) => setFormData({...formData, username: e.target.value})}
                  required
                />
              </div>
            </div>
            
            <div className="form-group">
              <div className="input-group contact-input mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text faq-icon">
                    <i className="fa fa-envelope-o" aria-hidden="true"></i>
                  </span>
                </div>
                <input
                  type="email"
                  name="email"
                  className="form-control box-bg light-v"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  required
                />
              </div>
            </div>
            
            <div className="form-group">
              <textarea
                name="description"
                className="form-control box-bg"
                placeholder="Your Message"
                rows="4"
                value={formData.description}
                onChange={(e) => setFormData({...formData, description: e.target.value})}
                required
              ></textarea>
            </div>
            
            <div className="con-btn-main">
              <button
                type="submit"
                className="con-btn"
                disabled={isContactSubmitting}
              >
                {isContactSubmitting ? (
                  <>
                    <i className="fa fa-spinner fa-spin"></i> Sending...
                  </>
                ) : (
                  'Get In Touch'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
      
      {/* NEWSLETTER SECTION */}
    <section id="subscribe">
        <div className="container">
            <div className="row">
                <div className="col-lg-8 m-auto">
                    <div className="sub-main">
                        <div className="row">
                            <div className="col-lg-8 col-md-7">
                                <h3>Stay Connected With Us</h3>
                            </div>
                            <div className="col-lg-3 col-md-5 subscripe-btn">
                                <a href="#" data-toggle="modal" data-target="#exampleModal2">Subscribe</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

              {/* Contact Modal */}
<div className={`modal fade ${showModal ? 'show' : ''}`} id="exampleModal" tabIndex="-1" role="dialog" 
     style={{ display: showModal ? 'block' : 'none', backgroundColor: showModal ? 'rgba(0,0,0,0.5)' : 'transparent' }}>
  <div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">
          {formData.plan ? `Interested in ${formData.plan} Plan` : 'Contact Our Team'}
        </h5>
      </div>
      <form onSubmit={handleContactSubmit}>
        <div className="modal-body">
          <div className="input-group contact-input mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text faq-icon">
                <i className="fa fa-user-o" aria-hidden="true"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control box-bg"
              placeholder="Your Name"
              value={formData.username}
              onChange={(e) => setFormData({...formData, username: e.target.value})}
              required
            />
          </div>
          
          <div className="input-group contact-input mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text faq-icon">
                <i className="fa fa-envelope-o" aria-hidden="true"></i>
              </span>
            </div>
            <input
              type="email"
              className="form-control box-bg"
              placeholder="Your Email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              required
            />
          </div>
          
          <div className="form-group">
            <textarea
              className="form-control box-bg"
              placeholder="How can we help you?"
              rows="3"
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              required
            ></textarea>
          </div>
          
          {formData.plan && (
            <input type="hidden" name="plan" value={formData.plan} />
          )}
        </div>
        <div className="modal-footer">
          <button
            type="submit"
            className="dropboxx2"
            disabled={isContactSubmitting}
          >
            {isContactSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

           <div className="modal fade show" id="exampleModal2" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title">Join Our Newsletter</h5>
                            </div>
                            <div className="modal-body">
                                <div className="input-group contact-input mb-3">
                                    <input
                                        type="email"
                                        className="form-control box-bg"
                                        placeholder="Enter your email address"
                                        aria-label="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="dropboxx2" disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        <span>
                                            <i className="fa fa-spinner fa-spin"></i> Submitting...
                                        </span>
                                    ) : (
                                        'Subscribe Now'
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

    <Footer/>
</div>
    </>
)
};

export default Homepage;